/*!
 * Main JS file script for Sogitec
 */

var Sogitec = (function($) {
	'use strict';

	var parseHash = function(currentHash) {
		var pureHash = currentHash.replace("#", "");
		var hashArray = pureHash.split("/");
		if (hashArray[1]) {
			var popinRef = "#" + hashArray[1];
			//wait section load before print modal
			setTimeout(function() {
				if (hashArray[2] !== undefined && hashArray[2].indexOf('slide') > -1) {
					var slide = hashArray[2].split(':');
					$('a[href="#'+hashArray[1]+'"]').each(function() {
						if ($(this).attr('data-slide_i') == slide[1]) {
							$(this).trigger('click');
						}
					});
				}
				else
					$('a[href="#'+hashArray[1]+'"]').trigger('click');
				$(popinRef).addClass('modal--is-active');
			}, 500);
		}
		window.location.hash = pureHash;
	};

	/**
	 * select2 plugin
	 */
	var select2 = function() {
		$('[data-js-select2]').select2({
			allowClear: true,
			minimumResultsForSearch: Infinity
		}).on('select2:open', function(evt) {
			var $scroller = $(this).closest('section').find('.fp-scroller');
			var previous = $scroller.css('transform');

			var interval = setInterval(function() {
				if (previous != $scroller.css('transform')) {
					$('[data-js-select2]').select2('close');
					clearInterval(interval);
				}
			}, 100);
		});
	};

	var formValidate = function() {
		$(document).ready(function() {
			$(".form").validate({
				rules: {
					/*"phone": {
						"regex": /^((\+33\(0\)[1679])|(0[1679])|(33[1679])|(\+33[1679]))[0-9]{8}$/
					},*/
					"contact_phone": {
						"isChecked":true
					}
				}
			});
		});

		function cleanPhone(phoneNumber) {
			var x = 0;
			phoneNumber = phoneNumber.replace(/\s/g, '');
			phoneNumber = phoneNumber.replace(/\./g, '');
			return(phoneNumber);
		}

		function isChecked() {
			var phone = $('input[name="contact_phone"]').is(":checked");
			var email = $('input[name="contact_email"]').is(":checked");
			var fax = $('input[name="contact_fax"]').is(":checked");

			if(!phone && !email && !fax) {
				return false;
			}
			return true;
		}

		$.validator.addMethod(
			"regex",
			function(value, element, regexp) {
				value = cleanPhone(value);
				if (regexp.constructor != RegExp)
					regexp = new RegExp(regexp);
				else if (regexp.global)
					regexp.lastIndex = 0;
					return this.optional(element) || regexp.test(value);
			},"Wrong phone format"
		);

		$.validator.addMethod(
			"isChecked",
			function(value, element) {
				if (isChecked()) {
					return true;
				}
				else {
					return false;
				}
			}, "Please select one way"
		);
	}

	var changeLang = function() {
		$(".link_lang").click(function(){
			var $display = $(".display_lang").css("display");
			if ($display == "none") {
				$(".display_lang").css("display", "flex");
			} else {
				$(".display_lang").css("display", "none");
			}
		});
	};

	var selectSocial = function() {
		$(".link-select__social").click(function(){
			var $display = $(".display_select__social").css("display");
			if ($display == "none") {
				$(".display_select__social").css("display", "flex");
			} else {
				$(".display_select__social").css("display", "none");
			}
		});
	};

	/**
	 * Fullpage plugin
	 * @param  {jQuery Object} $element [Element to receive the plugin]
	 * @param  {object} options  [options for the plugin]
	 */
	var fullpage = function($element, options) {
		$element.fullpage(options);

		$('[data-js-scrolldown]').on('click', function(event) {
			$.fn.fullpage.moveSectionDown();
			event.preventDefault();
		});
	};

	/**
	 * Modal system
	 */
	var modales = function() {
		var $modalOpen = $('[data-js-modal="open"]');
		var $modalClose = $('[data-js-modal="close"]');
		var currentHash;
		var popinRef;
		var $tmpModal;
		var $modalesContainer;

		$modalOpen.off('click');
		$modalOpen.on('click', function(event) {
			event.preventDefault();

			popinRef = $(this).attr('href');

			currentHash = window.location.hash;
			if (currentHash.length) {
				window.location.hash = currentHash + '/' + popinRef.replace("#", "");
			}

			if ($(this).attr('data-slide_i')) {
				$(this).closest('section.section').find('.carousel').slick('slickGoTo', $(this).attr('data-slide_i'), true);
			}

			var section_anchor = $(this).closest('.section').attr('data-anchor');
			$modalesContainer = $('.section[data-anchor='+section_anchor+'] .modales');

			$('body').prepend($(popinRef));

			$(popinRef).addClass('modal--is-active');
			disableScroll();
		});

		$modalClose.off('click');
		$modalClose.on('click', function(event) {
			event.preventDefault();

			$(this).parents('.modal').removeClass('modal--is-active');
			$modalesContainer.append($(this).parents('.modal'));

			currentHash = location.hash;

			if (currentHash.length) {
				var hashArray = currentHash.replace('#', '').split('/');
				if (hashArray.length > 0)
					window.location.hash = hashArray[0];
			}
			enableScroll();
		});
	};

	/**
	 * Simple accordion menu system
	 */
	var accordion = function() {
		$('.hex').on('click', function() {
			$(".l-accordion__slide").removeClass("l-accordion__slide--is-open");
			$(this).closest(".l-accordion__slide").addClass("l-accordion__slide--is-open");
		});
	};

	/**
	 * Footer deployment system
	 */
	var footerDeploy = function() {
		var $footerToggle = $('.footer-toggle');

		$footerToggle.off('click');
		$footerToggle.on('click', function(event) {
			$(this).closest(".page-footer").toggleClass("page-footer--is-open");
			event.preventDefault();
		});

		$footerToggle.off('mouseleave');
		$(".page-footer").on('mouseleave', function() {
			$(this).removeClass('page-footer--is-open');
		});
	};

	/**
	 * Add news when click on "see more"
	 * @param {jQuery Object} $fullpage [description]
	 */
	var addNews = function($fullpage) {
		var $this = $('[data-js-news-more]');
		var $items = $('.c-news .l-grid-3');
		var url    = '/aosogitec/news/';
		var $modales = $this.closest('section.section').find('.modales');

		addElements($fullpage, $this, $items, url, $modales, function(main_class, class_type, page) {
			var datas = {'main_class': main_class, 'class_type': class_type, 'type': 'modal'};
			$.post(url+page, datas, function(newElements) {
				$modales.append(newElements);

				fullPageRebuild($fullpage);
				modales();
				slick(true);

				setTimeout(function() {
					fullPageRebuild($fullpage);
				}, 500);
			});
		});
	};

	/**
	 * Add photos when click on "see more"
	 * @param {jQuery Object} $fullpage [description]
	 */
	var addPhotos = function($fullpage) {
		var $this  = $('[data-js-photos-more]');
		var $items = $this.closest('section.section').find('.c-news .l-grid-3');
		var url    = '/aosogitec/photos/';
		var $modales = $this.closest('section.section').find('.carousel');

		addElements($fullpage, $this, $items, url, $modales, function(main_class, class_type, page) {
			var datas = {'main_class': main_class, 'class_type': class_type, 'type': 'modal'};

			$.post(url+page, datas, function(newElements) {
				$modales.slick('slickAdd', newElements);

				$modales.find('.slick-prev, .slick-next').off('click');
				$modales.find('.slick-prev').on('click', function() {
					$modales.slick('slickPrev');
				});

				$modales.find('.slick-next').on('click', function() {
					$modales.slick('slickNext');
				});

				fullPageRebuild($fullpage);
				modales();
				slick(true);
				setTimeout(function() {
					share();
				},200)
			});
		});
	};

	var addElements = function($fullpage, $this, $items, url, $modales, callback) {
		var page = 2;
		var total_page = $this.attr('data-total_page');
		var main_class = $this.closest('section').attr('data-main_class');
		var class_type = $this.closest('section').attr('data-class_type');

		$this.on('click', function(event) {
			$('.c-news__mask').slideDown();

			event.preventDefault();

			var current_url = document.location.href.replace(/#.*$/, "");

			var datas = {'main_class': main_class, 'class_type': class_type, 'type': 'default', 'current_url': current_url};

			$.post(url+page, datas, function(newElements) {
				$items.append(newElements);

				if (!newElements) {
					$('.c-news__loader').fadeOut();
				}

				$('.c-news__mask').slideDown(500, function() {
					fullPageRebuild($fullpage);
					$('[data-js-select2]').select2('close');
				});

				modales();
				slick(true);

				page++;
			});

			if (typeof(callback) == 'function') {
				callback(main_class, class_type, page);
			}
		});
	};

	var fullPageRebuild = function($fullpage) {
		if (scrollOverflow) {
			$fullpage.reBuild();
		}
	}

	var filterPhotosGallery = function($fullpage) {
		if ($('.photo_category').length) {
			$('.photo_category').change(function() {
				var $this = $(this);
				var $items = $this.closest('section').find('.c-news .l-grid-3');
				var page = 1;
				var total_page = $this.attr('data-total_page');
				var main_class = $this.closest('section').attr('data-main_class');
				var class_type = $this.closest('section').attr('data-class_type');
				var url = $this.closest('form').attr('action')+'/';
				var category = $this.val();
				var $modales = $this.closest('section.section').find('.carousel');
				var datas = {'main_class': main_class, 'class_type': class_type, 'type': 'default', 'category': category };
				var refresh = 0;
				var refreshInterval = setInterval(function() {
					if (refresh >= 2) {

						setTimeout(function() {
							modales();
							slick(true);
							fullPageRebuild($fullpage);
						}, 500);

						clearInterval(refreshInterval);
					}
				}, 100);

				$.post(url+page, datas, function(newElements) {

					if (page >= total_page) {
						$('.c-news__loader').fadeOut();
					}

					$items.html(newElements);
					$('.c-news__mask').show();
					$items.slideDown(500, function() {
						fullPageRebuild($fullpage);
						$('[data-js-select2]').select2('close');
					});

					page++;
					refresh++;
				});

				$modales.slick('unslick');

				var datas = {'main_class': main_class, 'class_type': class_type, 'type': 'modal', 'category': category };
				$.post(url+page, datas, function(newElements) {

					$modales.slick('unslick');
					$modales.html(newElements);

					refresh++;
				});
			})
		}
	};

	var filterJobsElements = function($fullpage, $this, see_more, page) {
		var $items = $this.closest('section').find('.c-jobs .l-grid-3');
		var total_page = $this.attr('data-total_page');
		var main_class = $this.closest('section').attr('data-main_class');
		var class_type = $this.closest('section').attr('data-class_type');
		var url = '/aosogitec/jobs/';

		var category = $this.closest('section').find('.sort-job-select--field').val();
		var location = $this.closest('section').find('.sort-job-select--locations').val();
		var offer_type = $this.closest('section').find('.sort-job-select--type').val();
		var search = $this.closest('section').find('.sort-job-input--keywords').val();

		var $modales = $this.closest('section.section').find('.carousel');
		var datas = {'main_class': main_class, 'class_type': class_type, 'type': 'default', 'category': category, 'offer_type': offer_type, 'location': location, 'search': search };

		$.post(url + page, datas, function(newElements) {

			if (see_more) {
				$items.append(newElements);
				$this.closest('section').find('.c-news__mask').slideDown(500, function() {
					fullPageRebuild($fullpage);
				});

				modales();
				slick(true);
				fullPageRebuild($fullpage);
				$('[data-js-select2]').select2('close');

				// if (page >= total_page) {
				// 	$this.closest('section').find('.c-news__loader').fadeOut();
				// }
			}
			else {
				$items.html(newElements);
				$('.c-news__mask').show();
				$items.slideDown(500, function() {
					fullPageRebuild($fullpage);
					$('[data-js-select2]').select2('close');
				});

				page = 1;
			}

			if ($('.c-jobs__item.no-results').length == 1)
				$('.c-jobs__loader').hide();
			else
				$('.c-jobs__loader').show();

			fullPageRebuild($fullpage);
		});
	};

	var filterJobs = function($fullpage) {
		var classes = new Array('.sort-job-select--field', '.sort-job-select--locations', '.sort-job-select--type');
		var page = 2;

		for(var x in classes) {
			if ($(classes[x]).length) {
				$(classes[x]).change(function() {
					page = 1;
					filterJobsElements($fullpage, $(this), false, page);
					page++;
				});
			}
		}

		var $sort_job_input__keywords = $('.sort-job-input--keywords');
		if ($sort_job_input__keywords.length) {
			$sort_job_input__keywords.closest('section').find('form').on('submit', function(e) {
				e.preventDefault();
			});
			$sort_job_input__keywords.blur(function() {
				page = 1;
				filterJobsElements($fullpage, $(this), false, page);
				page++;
			});
		}


		if ($('[data-js-jobs-more]').length) {
			$('[data-js-jobs-more]').on('click', function() {
				filterJobsElements($fullpage, $(this), true, page);
				page++;
			});
		}
	};

	var filterArchivesElements = function($fullpage, $this) {
		var $items = $this.closest('section').find('.c-news .l-grid-3');
		var total_page = $this.attr('data-total_page');
		var main_class = $this.closest('section').attr('data-main_class');
		var class_type = $this.closest('section').attr('data-class_type');
		var url = '/aosogitec/news/';

		var category = $this.closest('section').find('.archive_category').val();
		var month = $this.closest('section').find('.archive_month').val();
		var year = $this.closest('section').find('.archive_year').val();
		var search = $this.closest('section').find('.archive_search').val();

		var $modales = $this.closest('section.section').find('.carousel');
		var datas = {'main_class': main_class, 'class_type': class_type, 'type': 'default', 'category': category, 'month': month, 'year': year, 'search': search, 'is_archive': 1 };

		$.post(url, datas, function(newElements) {
			$items.html(newElements);
			$('.c-news__mask').show();
			$items.slideDown(500, function() {
				fullPageRebuild($fullpage);
				$('[data-js-select2]').select2('close');
			});

			fullPageRebuild($fullpage);
		});
	};

	var filterArchives = function($fullpage) {
		var classes = new Array('.archive_category', '.archive_month', '.archive_year');
		var page = 2;

		for(var x in classes) {
			if ($(classes[x]).length) {
				$(classes[x]).change(function() {
					page = 1;
					filterArchivesElements($fullpage, $(this), false, page);
					page++;
				});
			}
		}

		if ($('.archive_search').length) {
			$('.archive_search').closest('section').find('form').on('submit', function(e) {
				e.preventDefault();
			});
			$('.archive_search').blur(function() {
				page = 1;
				filterArchivesElements($fullpage, $(this), false, page);
				page++;
			});
		}
	};

	var newsletterRegistration = function() {
		if ($('.sign-up__form').length > 0) {
			$('.sign-up__form').on('submit', function(e) {
				e.preventDefault();
				$.post('/aosogitec/newsletter_save', {'email' : $('#edit-newsletter-email').val()}, function(response) {
					alert(response.message);
				});
			});
		}

		if ($('.form-nl').length > 0) {
			$('.form-nl').on('submit', function(e) {
				e.preventDefault();
				$.post('/aosogitec/newsletter_save', {'email' : $('#email-nl').val()}, function(response) {
					alert(response.message);
				});
			});
		}
	};

	var subnav = function() {
		if ($('.subnav').length){
			$('.subnav_button').click(function() {
				$('.subnav').toggleClass('open');
			});
			$('.subnav ul li a').click(function() {
				$('.subnav').removeClass('open');
			});
		} else {
			$('.section-scrolldown').addClass("nosubnav");
		}
	};

	/**
	 * Main navigation component
	 */
	var mainNav = function() {
		var $menu = $('.menu'),
			$menuOpener = $('[data-js-menu="opener"]'),
			$menuOverlay = $('.menu-overlay'),
			$pageHeader = $('.page-header__logo'),
			menuClassActive = 'menu--is-active',
			menuLinkClassActive = 'menu__link--is-open',
			headerClassActive = 'page-header__logo--on-menu';

		$menuOpener.on('click', function() {
			$menu.toggleClass(menuClassActive);
			$pageHeader.toggleClass(headerClassActive);
		});

		$menuOverlay.on('click', function() {
			$menu.removeClass(menuClassActive);
			$pageHeader.removeClass(headerClassActive);
		});

		$menu.on('click', '.menu__link--has-submenu', function(event) {
			event.preventDefault();
			$(this).toggleClass(menuLinkClassActive).next('.menu__submenu').slideToggle();
			$(this).siblings().removeClass(menuLinkClassActive).next('.menu__submenu').slideUp();
		});
	};

	/**
	 * Slider component
	 */
	var slick = function(reload) {
		var $carrousel = $('.carousel');

		if (reload) {
			if ($carrousel.length) {
				$carrousel.each(function() {
					if(!$(this).hasClass('slick-initialized')) {
						var $this = $(this);
						$this.slick({swipe: $this.attr('data-slide_swipe') ? $this.attr('data-slide_swipe') : true});

						$('.slick-prev').on('click', function() {
							$this.slick('slickPrev');
						});
						$('.slick-next').on('click', function() {
							$this.slick('slickNext');
						});
					}
				});
			}
			return;
		}

		if ($carrousel.length) {
			$carrousel.each(function() {
				var $this = $(this);
				$this.slick({
					arrows: false,
					swipe: $this.attr('data-slide_swipe') ? false : true
				});

				$('.slick-prev').on('click', function() {
					$this.slick('slickPrev');
				});
				$('.slick-next').on('click', function() {
					$this.slick('slickNext');
				});
			});
		}
	};

	var slideTextClose = function() {
		$('[data-js-slide-map="close"]').on('click', function(event) {
			event.preventDefault();

			$('.slide-text.active').removeClass('active');
		});
	};

	// HEADER EXPANDING SEARCH FIELD
	var searchbox = function () {
		$('.searchbox_icon').on('click', function(e) {
			e.preventDefault();
			if ($('.searchbox_input').css('display') == 'block') {
				$('.searchbox_input').attr('placeholder', '');
			}
			$('.searchbox_input').stop(false, false).animate({
				width: 'toggle'
			}, 500, function() {
				$('.searchbox_input').attr('placeholder', $('.searchbox_input').data('placeholder'));
			});
		});

		$('.searchbox_input').on('focusout', function(e) {
			if (!$('searchbox_input').val()) {
				$('.searchbox_input').attr('placeholder', '');
				$('.searchbox_input').stop(false, true).animate({
					width: 'toggle'
				}, 500);
			}
		});
	};

	var animateNumbers = function($element, options, speed) {
		$element.animateNumber(options, speed);
	};

	var timeline = function() {
		var $timeline = $('.c-timeline__events .c-carrousel');

		$timeline.slick({
			infinite: false,
			dots: false,
			arrows: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						infinite: false,
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						infinite: false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	};

	var formatEvents = function() {
		var $events = $('.c-events');
		if ($events.length >= 1) {
			var $items = $events.find('.c-events__item');

			if (!scrollOverflow) {
				$items.each(function(i, item) {
					if ($(this).attr('data-js-modal-href')) {
						$(this).prop('href', $(this).attr('data-js-modal-href'));
					}
				});
			} else {
				$items.each(function(i, item) {
					$(this).removeAttr('data-js-modal data-js-modal-href data-slide_i');
				});
				$events.closest('section').find('.modales').remove();
			}

			$events.find('.c-events-slide__content').each(function(i, item) {
				var content = $(this).html().replace('c-events-slide__title', 'slide-subtitle');
				$events.closest('section').find('.carousel-slide .slide-text-content').eq(i).html(content);
			});
		}
	}

	var share = function() {
		$('.c-share__item--has-subitems > img').each(function() {
			var $this = $(this);
			$this.off('click');
			$this.on('click', function(e) {
				e.preventDefault();
				$this.closest('.c-share__item--has-subitems').toggleClass('c-share__item--is-active');
			});
		});
	};

	// left: 37, up: 38, right: 39, down: 40,
	// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
	var keys = {37: 1, 38: 1, 39: 1, 40: 1};

	function preventScroll(e) {
		e = e || window.event;
		if (e.preventDefault) {
			e.preventDefault();
		}
		e.returnValue = false;
	}

	function preventDefaultForScrollKeys(e) {
		if (keys[e.keyCode]) {
			preventScroll(e);
			return false;
		}
	}
	var disableScroll = function() {
		window.onwheel = preventScroll;
		window.onmousewheel = document.onmousewheel = preventScroll;
		window.ontouchmove  = preventScroll;
		document.onkeydown  = preventDefaultForScrollKeys;
		$.fn.fullpage.setMouseWheelScrolling(false);
		$.fn.fullpage.setAllowScrolling(false);
	};

	var enableScroll = function() {
		window.onmousewheel = document.onmousewheel = null;
		window.onwheel = null;
		window.ontouchmove = null;
		document.onkeydown = null;
		$.fn.fullpage.setMouseWheelScrolling(true);
		$.fn.fullpage.setAllowScrolling(true);
	};

	var youtube = function() {
		var $overlay = $('.video-clicker');
		if ($overlay.length === 0)
			return;

		var $video = $overlay.parents('.video').find('iframe');
		var videoSrc = $video[0].src;
		var isPlayed = false;

		$overlay.on('click', function() {
			if (!isPlayed) {
				$video.attr('src', videoSrc + '&autoplay=1');
				isPlayed = true;
			}
			else {
				$video.attr('src', videoSrc);
				isPlayed = false;
			}
		});
	};

	return {
		fullpage: fullpage,
		modales: modales,
		select2: select2,
		formValidate: formValidate,
		changeLang: changeLang,
		selectSocial: selectSocial,
		accordion: accordion,
		addNews: addNews,
		addPhotos: addPhotos,
		// addJobs: addJobs,
		footerDeploy: footerDeploy,
		newsletterRegistration: newsletterRegistration,
		subnav: subnav,
		slick: slick,
		parseHash: parseHash,
		filterPhotosGallery: filterPhotosGallery,
		filterJobs: filterJobs,
		filterArchives: filterArchives,
		mainNav: mainNav,
		slideTextClose: slideTextClose,
		animateNumbers: animateNumbers,
		searchbox: searchbox,
		timeline: timeline,
		formatEvents: formatEvents,
		share: share,
		disableScroll: disableScroll,
		enableScroll: enableScroll,
		youtube: youtube
	};
})(jQuery);

var LEGACY_SUPPORT = false; //for svg4everybody / ie11
var windowWidth = window.innerWidth
		|| document.documentElement.clientWidth
		|| document.body.clientWidth;
var scrollOverflow = windowWidth > 980 ? true : false;

jQuery(function() {
	var numberLoaded = false;

	svg4everybody();

	Sogitec.parseHash(document.location.hash);

	Sogitec.fullpage(jQuery('.fullpage'), {
		navigation: true,
		scrollOverflow: scrollOverflow,
		scrollOverflowOptions: {
			preventDefault: false,
			click: false, //fix for ipad checkbox
			preventDefaultException: { tagName:/.*/ } //fix for ipad checkbox
		},
		bigSectionsDestination: 'top',
		responsiveWidth: 980,
		fitToSection: false,
		fitToSectionDelay: 400,
		onLeave: function(index, nextIndex, direction) {
			var isFirstSlide = 1 === nextIndex ? true : false;

			jQuery('.page-header').toggleClass('page-header--full', !isFirstSlide);
			jQuery('.subnav').toggleClass('top', !isFirstSlide);

			// Subnav
			if (jQuery('.subnav').length){
				// apply active class on subnav
				jQuery('.subnav a').removeClass('active');
				jQuery('.subnav').removeClass("orange blue violet green");
				var subnavIndex = nextIndex - 2;
				if (nextIndex > 1) {
					// apply color for anchor only if not first slide
					jQuery('.subnav li').eq(subnavIndex).children('a').addClass('active');
					// Apply color to subnav for colored border bottom
					var anchorClassList = jQuery('.subnav li').eq(subnavIndex).children('a').attr('class').split(/\s+/);
					var colorClass = "";
					if (anchorClassList.length) {
						colorClass = anchorClassList[0];
					}
					else {
						colorClass = jQuery('.subnav li').eq(subnavIndex).children('a').attr('class');
					}
					jQuery('.subnav').addClass(colorClass);
				}
			}


			// pause video on leave first slide
			// assuming there is always a video on the first slide
			if (index === 1 && jQuery('.video-background--item').length) {
				document.querySelector('.video-background--item').pause();
			}
			// close accordion on leave second slide
			if (index === 2 && jQuery('.l-accordion').length) {
				jQuery('.l-accordion__slide').removeClass('l-accordion__slide--is-open');
			}

			$('[data-js-select2]').select2('close');
		},

		afterLoad: function(anchorLink, index){
			var loadedSection = jQuery(this);
			var isLastSlide = index === jQuery('.fullpage .section').length ? true : false;
			var video = document.querySelector('.video-background--item');

			if (video !== null && video.readyState === 4) {
				video.classList.add('video-background--visible');
			}

			// continue video on first slide
			// assuming there is always a video on the first slide
			if (index === 1 && jQuery(video).length){
				video.play();
			}

			if (index === 4 && jQuery('.about-us').length && numberLoaded === false) {
				numberLoaded = true;
				jQuery('[data-js-animate-number]').each(function() {
					var $this = jQuery(this);

					Sogitec.animateNumbers($this, { number: $this.attr('data-js-animate-number') }, 800);
				});
			}

			// Show footer link if last slide
			jQuery('.footer-toggle').toggleClass('footer-toggle--is-hidden', !isLastSlide);

		},
		afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex) {
			jQuery('.slide-text').removeClass('active');
			if (anchorLink === 'history' && slideIndex !== 0) {
				jQuery(this).find('.slide-text').addClass('active');
			}
		},

		afterRender: function() {
			var $fullpage = jQuery.fn.fullpage;

			Sogitec.addNews($fullpage);
			Sogitec.addPhotos($fullpage);
			// Sogitec.addJobs($fullpage);
			Sogitec.subnav();
			Sogitec.filterPhotosGallery($fullpage);
			Sogitec.filterJobs($fullpage);
			Sogitec.filterArchives($fullpage);
			Sogitec.mainNav();
		}
	});

	//var $fullpage = jQuery.fn.fullpage;
	Sogitec.formatEvents();
	Sogitec.modales();
	Sogitec.accordion();
	Sogitec.select2();
	Sogitec.formValidate();
	Sogitec.changeLang();
	Sogitec.selectSocial();
	Sogitec.footerDeploy();
	Sogitec.newsletterRegistration();
	Sogitec.slick();
	Sogitec.slideTextClose();
	Sogitec.searchbox();
	Sogitec.timeline();
	Sogitec.share();
	Sogitec.youtube();
});
